import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {Observable} from 'rxjs';
import {WorkflowDefinitionControllerService} from '../../api/api/workflowDefinitionController.service';
import {SUPPRESS_ERROR_HANDLING} from '../../interceptors/http-error.interceptor';
import {RuleTestQuota, RuleTestRunView, RuleTestStartRequest} from './rule-test.models';

/**
 * Handgeschriebener Client für `/workflows/rule-tests` – `src/app/api` ist generiert und
 * gitignored (Muster wie in `ruleset.service.ts`). Fehler werden NICHT vom globalen Interceptor
 * als Toast gezeigt: 422/429/409 sind erwartete Zustände, die das Popup selbst darstellt.
 */
@Injectable({providedIn: 'root'})
export class RuleTestApi {
  private http = inject(HttpClient);
  private definitionApi = inject(WorkflowDefinitionControllerService);

  private get basePath(): string {
    return `${(this.definitionApi as any).basePath ?? ''}/workflows/rule-tests`;
  }

  private get quiet(): {context: HttpContext} {
    return {context: new HttpContext().set(SUPPRESS_ERROR_HANDLING, true)};
  }

  getQuota(): Observable<RuleTestQuota> {
    return this.http.get<RuleTestQuota>(`${this.basePath}/quota`, this.quiet);
  }

  start(projectId: number, request: RuleTestStartRequest): Observable<RuleTestRunView> {
    return this.http.post<RuleTestRunView>(this.basePath, request, {...this.quiet, params: {projectId}});
  }

  get(runId: string, projectId: number): Observable<RuleTestRunView> {
    return this.http.get<RuleTestRunView>(`${this.basePath}/${encodeURIComponent(runId)}`, {
      ...this.quiet,
      params: {projectId},
    });
  }
}
